import type { User } from "~/types/user";

export function isGuestUser(user: User | null) {
  return !user || user.basicInfo.email.endsWith("@fake.email");
}
